<template>
  <UserProfileCard
    name="Privacy"
    class="mx-auto"
    style="max-width: 800px;"
  >
    <hr class="my-0"/>
    <b-button
      block
      variant="link"
      class="settings-button"
      style="text-decoration: none; box-shadow: none;"
      @mousedown="collapse = !collapse"
    >
    <b-row class="align-items-center">
        <b-col col class="text-muted justify-content-center d-flex">
          RESET PASSWORD
        </b-col>
      </b-row>
    </b-button>
    <b-collapse  @show="reset" @hidden="reset" :id="'password'"
    v-model="collapse" class="card-text px-5">
      <div class="mt-3">
        <form @submit.stop.prevent="passwordReset">
          <b-alert :show="invalid" variant="warning" class="text-xs mb-4">
           {{ processingError }}
          </b-alert>
          <b-row class="align-items-center">
            <b-col cols="4" class="text-muted justify-content-start d-flex">
              New Password
            </b-col>
            <b-col col class="justify-content-end d-flex pr-5">
              <b-form-input
                placeholder="New password"
                class="text-right normalize"
                v-model="newPassword"
                :type="showPassword ? 'text' : 'password'"
                required
              ></b-form-input>
              <b-button
                type="button"
                class="text-gray-500 text-xs position-absolute border-0 py-0 px-1"
                variant="light"
                style="right: 0; top: 35%; background: var(--bg-color)"
                @click="showPassword = !showPassword"
              >
                <b-icon
                    :icon="showPassword ? 'eye' : 'eye-slash'"
                ></b-icon>
              </b-button>
            </b-col>
          </b-row>
          <b-row class="align-items-center">
            <b-col cols="4" class="text-muted justify-content-start d-flex">
              Confirm Password
            </b-col>
            <b-col col class="justify-content-end d-flex pr-5">
              <b-form-input
                placeholder="Password confirmation"
                class="text-right normalize"
                v-model="passwordConfirmation"
                :type="'password'"
                @blur="validate()"
                required
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="align-items-center">
            <b-col col class="text-muted justify-content-center d-flex">
              <b-button
              class="mt-4 my-1 mr-1 rounded-pill"
              type="submit"
              >
                reset
              </b-button>
            </b-col>
          </b-row>
        </form>
      </div>
    </b-collapse>
    <hr class="my-0"/>
  </UserProfileCard>
</template>

<script>
import UserProfileCard from './UserProfileCard.vue';
import { resetPassword } from '../api/user';

export default {
  name: 'UserProfilePrivacy',
  components: { UserProfileCard },
  data() {
    return {
      collapse: false,
      newPassword: '',
      passwordConfirmation: '',
      showPassword: false,
      invalid: false,
      processingError: '',
    };
  },
  methods: {
    validate() {
      this.invalid = this.newPassword !== this.passwordConfirmation;
      if (this.invalid) {
        this.processingError = 'Password does not match. Please try again.';
      }
    },
    reset() {
      this.newPassword = '';
      this.passwordConfirmation = '';
      this.showPassword = false;
      this.invalid = false;
    },
    passwordReset() {
      const data = { data: { password: this.newPassword } };
      resetPassword(data).then((resp) => {
        console.log('Successfully POSTed');
        console.log(resp);
        this.collapse = !this.collapse;
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>

</style>
